












import { Vue, Component, Prop } from 'vue-property-decorator'
import DemandTargetOptPage from '@/views/newPension/pensionCard/demandTarget/outputPage.vue' // 需求目标输出页面
import reserveAnalysisOptPage from '@/views/newPension/pensionCard/reserveAnalysis/outputPage.vue' // 财务储备分析输出页面
import GapOptPage from '@/views/newPension/components/gap/index.vue' // 缺口分析输出页面
import LifeOptPage from '@/views/newPension/pensionCard/lifeProduct/index.vue' // 寿险输出页面
import AnnuityOptPage from '@/views/newPension/pensionCard/annuityProduct/index.vue' // 年金输出页面
import InvestOutPage from '@/views/newPension/pensionCard/investCard/outPage.vue' // 投资产品输出页面
import { PersionModule } from '@/store/modules/pension'
@Component({
  components: {
    DemandTargetOptPage,
    reserveAnalysisOptPage,
    GapOptPage,
    LifeOptPage,
    AnnuityOptPage,
    InvestOutPage
  }
})
export default class TotalDetail extends Vue {
    @Prop({ default: false }) download!: boolean
    // pageList = [{
    //   page: DemandTargetOptPage
    // }, {
    //   page: reserveAnalysisOptPage
    // }, {
    //   page: GapOptPage
    // }, {
    //   page: LifeOptPage
    // }, {
    //   page: AnnuityOptPage
    // },
    // {
    //   page: InvestOutPage
    // }
    // ]

    getTableShow () {
      return PersionModule.tableShow
    }
}
